import { observable } from "@legendapp/state"
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage"
import { synced } from "@legendapp/state/sync"

export type TStatsSampleDataOverrideMode = "auto" | "force_on" | "force_off"

interface StatsSampleDataDevOverridesState {
  sampleDataMode: TStatsSampleDataOverrideMode
}

export const statsSampleDataDevOverride$ = observable(
  synced<StatsSampleDataDevOverridesState>({
    initial: {
      sampleDataMode: "auto",
    },
    persist: {
      name: "statsSampleDataDevOverride",
      plugin: ObservablePersistLocalStorage,
    },
  })
)
